import moment from 'moment/src/moment';

export const timestampFormat = (timestamp, format) => {
    return moment(timestamp).format(format);
}

export const filterRecentNotifications = (notifications) => {
    const now = moment();
    return notifications.filter(notification => {
      const notificationTime = moment(notification.updated_at);
      return now.diff(notificationTime, 'hours') < 24;
    });
}